var _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 71,
    viewBox: "0 0 47 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 45,
    height: 69,
    rx: 22.5,
    stroke: "white",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 45,
    width: 19,
    height: 19,
    fill: "url(#pattern0_11_111)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_11_111",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_11_111",
    transform: "scale(0.01)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_11_111",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAABh0lEQVR4nO3awUkDURRG4QE3bgISi3BhDS5sRSwgVbgJiGgVWoqCrwDBnTWICB4ZiCtDMpu8ue/d80FgVpN/5jAkhAyDJEmSJEmSJEmSJEmSJEmSJEmHBBzN+eYXwAvwDbwBV0NSwDXwDvwABbisPeAM+OS/9ZAMsN5yH76A85oj7raMSBeF7TH+PNQc8rhjSIoo7I4xeqo5ZrVnTNdR2B9jtKo56HjzgZ4uCtNijPfmuPawk4lRbodOADcTrnf8lnU618A0UYgeI1MUWomRIQqtxeg5Cq3G6DEKrcfoKQq9xOghCr3FaDkKvcZoMQq9x2gpCllitBCFbDEiRyFrjIhRyB4jUhSMEScKxtgZ5blmFIwRJwrGiBMFY8SJgjHiRMEYcaJgjDhRMEacKBgjThSMcVjAEnidEGU98R+F47mWB57dN6Y/Kfv0/0NhQ1GKMeJEKcaIE6UYI06UYow4UYox4kQpxpgJsADugY/NazxezLVHkiRJkiRJkiRJkiRJkiRJkqQhhV9HD6QE7j5SZQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2);
export default __webpack_public_path__ + "static/media/Group 2.40d64d36b86507b8ac67ea07bd7de2e5.svg";
export { ForwardRef as ReactComponent };